<template>
    <div id="reduce_detail">
        <top></top>
        <div class="mian" :style="{ height: mianH + 'px' }">
            <div class="reduce-detail">
                <!-- 顶部导航 -->
                <div class="detail-header">
                    <div class="back-btn" @click="$router.back()">
                        <i class="el-icon-arrow-left"></i>
                    </div>
                    <h2 class="detail-title">降痕详情</h2>
                    <div class="header-placeholder"></div>
                </div>

                <!-- 加载中 -->
                <div v-if="loading" class="detail-loading">
                    <i class="el-icon-loading"></i>
                    <span>正在加载详情...</span>
                </div>

                <!-- 对比内容 -->
                <div v-else class="detail-content">
                    <!-- 信息栏：类型 + 版本 + 强度 + 创建时间 -->
                    <div class="detail-info-bar">
                        <span class="info-item">
                            稿件类型：<b>{{ detailInfo.type || '未知' }}</b>
                        </span>
                        <span class="info-item" v-if="detailInfo.version">
                            消痕版本：<b>{{ detailInfo.version }}</b>
                        </span>
                        <span class="info-item" v-if="detailInfo.level">
                            改写强度：<b>{{ detailInfo.level }}</b>
                        </span>
                        <span class="info-item">
                            创建时间：<b>{{ detailInfo.completed || '未知' }}</b>
                        </span>
                    </div>
                    <!-- 左侧：原文对比 -->
                    <div class="content-panel">
                        <div class="panel-header">
                            <div class="panel-header-left">
                                <i class="el-icon-document"></i>
                                <span>原文对比</span>
                            </div>
                               <div class="panel-header-right">
                                <span class="result-count">结果字数 {{compareOriginalLength }}</span>
                            </div>
                        </div>
                        <div class="editor-area diff-area diff-left">
                            <div class="diff-content" v-html="compareOriginalHtml()"></div>
                        </div>
                    </div>

                    <!-- 右侧：消痕后内容 -->
                    <div class="content-panel">
                        <div class="panel-header">
                              <div class="panel-header-left">
                                <span>消痕后内容</span>
                            </div>
                            <div class="panel-header-right">
                                <span class="result-count">结果字数 {{ resultTextLength }}</span>
                            </div>
                        </div>
                        <div class="editor-area diff-area diff-right">
                            <div class="diff-content" v-html="compareResultHtml()"></div>
                        </div>
                        <div class="result-actions">
                            <el-button size="small" icon="el-icon-document-copy" @click="handleCopy">复制</el-button>
                            <el-button size="small" icon="el-icon-download" @click="handleDownload('txt')">下载 TXT</el-button>
                            <el-button size="small" icon="el-icon-download" @click="handleDownload('word')">下载 Word</el-button>
                             <el-button size="small" icon="el-icon-download" @click="handleTrage()">朱雀检测</el-button>
                        
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import top from '../components/top.vue'
import api from '@/api/api';
export default {
    components: { top },
    data() {
        return {
            mianH: 0,
            loading: true,
            logId: '',
            resultContent: '',
            compareOrigina:'',
            compareData: null,
            detailInfo: {}        // 详情信息（类型、创建时间等）
        }
    },
    computed: {
        resultTextLength() {
            return this.stripHtml(this.resultContent).length
        },
        compareOriginalLength() {
            return this.stripHtml(this.compareOrigina).length
        }
    },
    mounted() {
        this.calculateMianHeight();
        window.addEventListener('resize', this.calculateMianHeight);
        const detailId = this.$route.query.id;
        if (detailId) {
            this.logId = detailId;
            this.loadDetail(detailId);
        } else {
            this.loading = false;
            this.$message.warning('缺少记录ID');
        }
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.calculateMianHeight);
    },
    methods: {
        handleTrage(){
            window.open("https://matrix.tencent.com/ai-detect/ai_gen", '_blank')
        },
        calculateMianHeight() {
            this.mianH = window.innerHeight - 63;
        },
        stripHtml(html) {
            const tmp = document.createElement('div')
            tmp.innerHTML = html || ''
            return (tmp.textContent || tmp.innerText || '').replace(/\u200B/g, '')
        },
        escapeHtml(text) {
            const div = document.createElement('div');
            div.textContent = text;
            return div.innerHTML;
        },
        loadDetail(logId) {
            this.loading = true;
            api.getReduceDetail({ logId: logId }).then((res) => {
                if (res.code === 200 && res.data) {
                    // 保存详情信息
                    this.detailInfo = {
                        type: this.formatType(res.data.type),
                        version: this.formatVersion(res.data.version),
                        level: this.formatIntensity(res.data.level),
                        completed: this.formatTime(res.data.completed)
                    };
                    const originalText = res.data.text || '';
                    const resultText = res.data.result || '';
                    this.resultContent = resultText.replace(/#/g, '');
                    this.compareOrigina = originalText.replace(/#/g, '');
                    this.compareData = {
                        originalSegments: this.parseMarkedText(originalText, 'delete'),
                        resultSegments: this.parseMarkedText(resultText, 'insert')
                    };
                } else {
                    this.$message.warning(res.msg || '获取详情失败');
                }
            }).catch((err) => {
                console.error('获取详情失败', err);
                this.$message.error('获取详情失败，请稍后重试');
            }).finally(() => {
                this.loading = false;
            });
        },
        // 类型映射
        formatType(type) {
            const map = { 'novel': '小说', 'script': '剧本', 'media': '公众号' };
            return map[type] || type || '未知';
        },
        formatVersion(version) {
            const map = { 'v2': '偏向低AI率', 'v3': '偏向自然表达' };
            return map[version] || version || '';
        },
        formatIntensity(level) {
            const map = { 1: '极低', 2: '低', 3: '中', 4: '高', 5: '极高' };
            return map[level] || (level ? String(level) : '');
        },
        formatTime(time) {
            if (!time) return '';
            const d = new Date(time);
            if (isNaN(d.getTime())) return time;
            const y = d.getFullYear();
            const m = String(d.getMonth() + 1).padStart(2, '0');
            const day = String(d.getDate()).padStart(2, '0');
            const h = String(d.getHours()).padStart(2, '0');
            const min = String(d.getMinutes()).padStart(2, '0');
            const s = String(d.getSeconds()).padStart(2, '0');
            return `${y}-${m}-${day} ${h}:${min}:${s}`;
        },
        parseMarkedText(text, markType) {
            if (!text) return [];
            const parts = text.split('#');
            const segments = [];
            for (let i = 0; i < parts.length; i++) {
                if (parts[i] === '') continue;
                segments.push({
                    type: i % 2 === 1 ? markType : 'equal',
                    text: parts[i]
                });
            }
            return segments;
        },
        compareOriginalHtml() {
            if (!this.compareData || !this.compareData.originalSegments) return '';
            return this.compareData.originalSegments.map(item => {
                if (item.type === 'equal') return this.escapeHtml(item.text);
                return `<span class="diff-del">${this.escapeHtml(item.text)}</span>`;
            }).join('');
        },
        compareResultHtml() {
            if (!this.compareData || !this.compareData.resultSegments) return '';
            return this.compareData.resultSegments.map(item => {
                if (item.type === 'equal') return this.escapeHtml(item.text);
                return `<span class="diff-add">${this.escapeHtml(item.text)}</span>`;
            }).join('');
        },
        handleCopy() {
            const text = this.stripHtml(this.resultContent)
            if (!text) {
                this.$message.warning('暂无内容可复制');
                return;
            }
            navigator.clipboard.writeText(text).then(() => {
                this.$message.success('已复制到剪贴板');
            });
        },
        handleDownload(type) {
            const text = this.stripHtml(this.resultContent)
            if (!text) {
                this.$message.warning('暂无内容可下载');
                return;
            }
            const blob = new Blob([text], { type: type === 'txt' ? 'text/plain' : 'application/msword' });
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = `消痕结果_${Date.now()}.${type === 'txt' ? 'txt' : 'doc'}`;
            a.click();
            URL.revokeObjectURL(url);
        },
    }
}
</script>

<style lang="scss" scoped>
#reduce_detail {
    width: 100%;
    height: 100vh;
    display: flex;
    flex-flow: column;
    overflow-y: hidden;   /* 原来是 overflow: hidden */
    overflow-x: auto;     /* 加这行 */
}

#reduce_detail .mian {
     width: 100%;
    padding-top: 20px;
    box-sizing: border-box;
    flex: 1;
    min-height: 0;
    overflow-y: hidden;   /* 原来是 overflow: hidden */
    overflow-x: auto;     /* 加这行 */
}

.reduce-detail {
    padding: 16px 24px 20px;
    background: #f5f7fa;
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%;
    box-sizing: border-box;

    .detail-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 14px;
        flex-shrink: 0;
    }

    .back-btn {
        width: 32px;
        height: 32px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        border-radius: 50%;
        transition: background 0.2s;

        &:hover {
            background: rgba(0, 0, 0, 0.04);
        }

        i {
            font-size: 18px;
            color: #333;
            font-weight: bold;
        }
    }

    .detail-title {
        font-size: 26px;
        font-weight: 700;
        color: #1a1a2e;
        margin: 0;
    }

    .header-placeholder {
        width: 32px;
    }
    // 结果操作栏
.result-actions {
    display: flex;
    justify-content: flex-end;
    gap: 8px;
    padding: 8px 12px;
    border-top: 1px solid #f0f0f0;
    background: #fafbfc;
    flex-shrink: 0;
    flex-wrap: wrap;
}

    .detail-loading {
        flex: 1;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 12px;
        color: #999;
        font-size: 14px;

        i {
            font-size: 28px;
            color: #4a8cff;
        }
    }

    .detail-content {
         display: grid;
    grid-template-columns: minmax(500px, 1fr) minmax(500px, 1fr);  /* 原来是 1fr 1fr */
    gap: 14px;
    flex: 1;
    min-height: 0;
    align-content: start;
    }

    // 信息栏
    .detail-info-bar {
        grid-column: 1 / -1;
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        gap: 16px 24px;
        padding: 10px 16px;
        background: #fff;
        border-radius: 10px;
        box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);
        flex-shrink: 0;
    }

    .info-item {
        display: flex;
        align-items: center;
        gap: 6px;
        font-size: 13px;
        color: #666;

        i {
            font-size: 15px;
            color: #4a8cff;
        }

        b {
            color: #333;
            font-weight: 600;
        }
    }

    .content-panel {
        background: #fff;
        border-radius: 10px;
        box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);
        display: flex;
        flex-direction: column;
        overflow: hidden;
        min-height: 500px;
    }

    .panel-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 8px 12px;
        border-bottom: 1px solid #f0f0f0;
        font-size: 13px;
        font-weight: 600;
        color: #333;
        flex-shrink: 0;
    }

    .panel-header-left {
        display: flex;
        align-items: center;
        gap: 6px;
    }

    .panel-header-right {
        display: flex;
        align-items: center;
        gap: 8px;
    }

    .result-count {
        font-size: 12px;
        color: #999;
    }

    .editor-area {
        flex: 1;
        min-height: 0;
        overflow: hidden;
        display: flex;
        position: relative;
    }
}

// ===== diff 对比区域 =====
.diff-area {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;

    &.diff-left {
        background: #fef9f9;
    }

    &.diff-right {
        background: #f8fdf8;
    }
}

.diff-legend-bar {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 6px 14px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.04);
    flex-shrink: 0;
}

.legend-item {
    display: flex;
    align-items: center;
    gap: 4px;
    font-size: 12px;
    color: #888;
}

.legend-del {
    display: inline-block;
    width: 16px;
    height: 3px;
    background: #e8463a;
    border-radius: 2px;
}

.legend-add {
    display: inline-block;
    width: 16px;
    height: 3px;
    background: #1dc981;
    border-radius: 2px;
}

.diff-content {
    flex: 1;
    overflow-y: auto;
    padding: 10px 14px;
    font-size: 16px;
    line-height: 1.75;
    color: #333;
    white-space: pre-wrap;
    word-break: break-all;
}

// diff 标记样式
:deep(.diff-del) {
    color: #e8463a;
    text-decoration: line-through;
    background: rgba(232, 70, 58, 0.06);
    border-radius: 2px;
    padding: 0 1px;
}

:deep(.diff-add) {
    color: #1dc981;
    text-decoration: underline;
    text-decoration-color: #1dc981;
    background: rgba(29, 201, 129, 0.06);
    border-radius: 2px;
    padding: 0 1px;
}

// =====================================================
//  响应式
// =====================================================
@media (max-width: 1024px) {
    .reduce-detail {
        padding: 12px 16px 16px;

        .detail-title {
            font-size: 20px;
        }

        .detail-content {
            gap: 10px;
        }
    }
}

@media (max-width: 768px) {
    #reduce_detail .mian {
        padding-top: 10px;
    }

    .reduce-detail {
        padding: 8px 12px 12px;

        .detail-header {
            margin-bottom: 10px;
        }

        .detail-title {
            font-size: 18px;
        }

        .detail-content {
            grid-template-columns: 1fr;
            gap: 10px;
        }

        .content-panel {
            min-height: 200px;
        }
    }
}

@media (max-width: 480px) {
    .reduce-detail {
        padding: 6px 8px 10px;

        .detail-title {
            font-size: 16px;
        }

        .detail-content {
            gap: 8px;
        }

        .panel-header {
            padding: 6px 10px;
            font-size: 12px;
        }

        .diff-content {
            padding: 8px 10px;
            font-size: 16px;
        }
    }
}
</style>
